export const rankStyles = [
	// Gold
	{
		podiumBg: "rgb(255, 224, 131)",
		textColor: "#685300",
		height: 156,
		marginTop: 16,
		avatarSize: 56,
		gradientColors: ["#F5D451", "#ffffff"] as const,
		borderGradientColors: ["rgb(185, 164, 58)", "#FFE259"] as const,
		chipColor: "rgba(251, 230, 128, 0.99)",
		topSurfaceColor: "#FFEDA7",
	},
	// Silver
	{
		podiumBg: "rgb(219, 228, 230)",
		height: 128,
		textColor: "#49454F",
		marginTop: 16,
		avatarSize: 48,
		gradientColors: ["#C7C7C7", "#ffffff"] as const,
		borderGradientColors: ["rgb(131, 131, 131)", "#E0E0E0"] as const,
		chipColor: "#E0E0E0",
		topSurfaceColor: "#E8E8E8",
	},
	// Bronze
	{
		podiumBg: "rgb(255, 220, 195)",
		textColor: "#854600",
		height: 112,
		marginTop: 16,
		avatarSize: 40,
		gradientColors: ["#FFB056", "#ffffff"] as const,
		borderGradientColors: ["rgb(175, 83, 40)", "#FFAD87"] as const,
		chipColor: "#FFAD87",
		topSurfaceColor: "#FFD6A8",
	},
];
